import { Component, Input, OnInit } from '@angular/core';
import { SkeletonSizeBase, VideoType } from '../../../common';

@Component({
  selector: 'skc-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.less']
})
export class VideoComponent extends SkeletonSizeBase implements OnInit {
  @Input('skc-show-media') showMedia = true;
  @Input('skc-show-play') showPlay = true;
  @Input('skc-video-type') videoType = VideoType.MEDIA;
  videoEnum = VideoType;
  constructor() {
    super();
  }

  ngOnInit() {}
}
